import { Injectable } from '@angular/core';
import { TokenStorageService } from './token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  constructor(private tokenStorage: TokenStorageService) {}

  getUsuarioId(): number | null {
    // Retrieve the user ID from the token storage service
    return this.tokenStorage.getUserId() ?? null;
  }

  getNombre(): string | null {
    const usuario = this.tokenStorage.getUser();
    return usuario?.nombre ?? null;
  }
}